import { Link } from "react-router-dom";
import styled from "styled-components";
import { media } from "../media";

export default function Header() {
  return (
    <HeaderWrap>
      <header>
        <h1>
          <Link to="/">GREENPARK</Link>
        </h1>
      </header>
    </HeaderWrap>
  );
}

const HeaderWrap = styled.header`
  width: 100vw;
  ${media.desktop`
    width: 393px;
`}
  header {
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #314af3;
    h1 {
      display: block;
      height: 32px;
      font-size: 40px;
      font-weight: 200;
      cursor: pointer;
      a {
        :hover {
          text-decoration: none;
        }
      }
    }
  }
`;
